<template>
  <SSelect :model-value="model" @update:model-value="onChange">
    <SSelectTrigger class="w-full">
      <SSelectValue :placeholder="placeholder ?? t('select.terminal')" />
    </SSelectTrigger>
    <SSelectContent>
      <SSelectItem
        v-for="terminal in terminals"
        :key="terminal"
        :value="terminal"
      >
        {{ terminal }}
      </SSelectItem>
    </SSelectContent>
  </SSelect>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import {
  SSelect,
  SSelectContent,
  SSelectItem,
  SSelectTrigger,
  SSelectValue,
} from "@smeetz/ui-core";

import POSConfigModule from "@/store/modules/pos-config";

const { t } = useI18n({ useScope: "global" });

const model = defineModel<string>();

defineProps<{ placeholder?: string }>();

const emit = defineEmits<{ doParentAction: [] }>();

const terminals = computed(() => POSConfigModule.groupTerminals);

/**
 * Update the bound value and notify the parent of the change.
 *
 * @param {string} value selected terminal id.
 * @returns {void}
 */
const onChange = (value: string) => {
  model.value = value;
  emit("doParentAction");
};
</script>
